/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SignInResponseDto } from '../../models/sign-in-response-dto';
import { TwoFactorRecoveryCodeSignInRequestDto } from '../../models/two-factor-recovery-code-sign-in-request-dto';

export interface TwoFactorRecoveryCodeSignIn$Params {
  'X-API-Version'?: string;
      body: TwoFactorRecoveryCodeSignInRequestDto
}

export function twoFactorRecoveryCodeSignIn(http: HttpClient, rootUrl: string, params: TwoFactorRecoveryCodeSignIn$Params, context?: HttpContext): Observable<StrictHttpResponse<SignInResponseDto>> {
  const rb = new RequestBuilder(rootUrl, twoFactorRecoveryCodeSignIn.PATH, 'put');
  if (params) {
    rb.header('X-API-Version', params['X-API-Version'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SignInResponseDto>;
    })
  );
}

twoFactorRecoveryCodeSignIn.PATH = '/api/session/mfa-recovery-code';
